import { Product } from "@utils/store/cart/useOrder";

/** 單筆品項金額：優先用 totalPrice，否則 unit_price × qty。 */
export const lineTotalOf = (item: Product): number => Number(item.totalPrice ?? (item.unit_price || 0) * (item.qty || 0));

/**
 * 把優惠券折扣「直接折在瓦斯品項上」：依各瓦斯品項金額比例攤折扣，
 * 最後一筆瓦斯吸收四捨五入餘數；非瓦斯品項不攤。
 *
 * @returns Map<line_id, 該筆折扣金額>；無折扣 / 無瓦斯品項時回空 Map。
 */
export const buildGasCouponDiscountMap = (productList: Product[], couponDiscount: number): Map<string, number> => {
  const map = new Map<string, number>();
  if (!(couponDiscount > 0)) return map;

  const gasSum = productList.reduce((sum, item) => sum + (item.gas_type ? lineTotalOf(item) : 0), 0);
  if (gasSum <= 0) return map;

  // 不信任外部資料：折扣上限為瓦斯總額，避免折扣 > 瓦斯小計時某筆顯示負數。
  const effectiveDiscount = Math.min(couponDiscount, gasSum);

  let lastGasIdx = -1;
  productList.forEach((item, i) => {
    if (item.gas_type) lastGasIdx = i;
  });

  let remaining = effectiveDiscount;
  productList.forEach((item, i) => {
    if (!item.gas_type) return;
    const discount = i === lastGasIdx ? remaining : Math.round((effectiveDiscount * lineTotalOf(item)) / gasSum);
    remaining -= discount;
    map.set(item.line_id ?? `idx-${i}`, discount);
  });
  return map;
};

/** 取某品項折扣後顯示金額（非瓦斯或無折扣時即原價）；防呆 clamp 不低於 0。 */
export const discountedLineTotal = (item: Product, index: number, discountMap: Map<string, number>): number =>
  Math.max(0, lineTotalOf(item) - (discountMap.get(item.line_id ?? `idx-${index}`) ?? 0));
